import React, { Fragment } from "react";
import { Dialog, DialogTitle, FormHelperText, Grid, TextField, FormControlLabel, Radio, } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import styled from "styled-components";
import { Formik } from "formik";
import { pull } from "lodash";
import moment from "moment";
import PrimaryButton from "components/Global/Buttons/PrimaryButton";
import SecondaryButton from "components/Global/Buttons/SecondaryButton";
import { DatePicker } from "components/Global/FormikMaterial";
import { CheckBox } from "@material-ui/icons";
import { CheckboxSelectListInput} from 'components/Global/FormikMaterial';

const PaddedDiv = styled.div`
  padding: 30px 10px 10px 30px;
`;

const DateFieldWrapper = styled.div`
 & div:first-child {
   width:100%;
 }
 & label {
   font-size:17px;
 }
 &&&&& div div::before {
  border-bottom: 1px solid #2196F3;
  }
  &&&&& div div:hover::before {
    border-bottom: 1px solid #2196F3;
  }
  &&&&& div div::after {
    border-bottom: 1px solid #006dab;
  }
  #fundModelDateField-helper-text {
    color: rgba(0,0,0,0.54);
    position:absolute;
    margin-top:56px;
  }
`;

const styles = () => ({
  dialogTitle: {
    color: "blue",
    padding: "30px 0 0 30px"
  },
  labelRoot: {
    
  },
  inputField: {
    borderBottom: "1px solid #2196F3",
    
  },
  error: {
    '& input':{
      borderBottom: '1px solid red'
    }
  }
});

class FundModal extends React.Component {

  closeModal = () => {
    this.props.onClose();  
  }

  onCancel = () => {
    this.props.onClose();
  }

  save = fund => {
    if (this.props.isEdit) {
      this.props.updateFund(fund);
      this.closeModal();
    } else {
      this.props.onSave(fund);
      this.closeModal();
    }
  }

  isValidFundName (fundName) {
    let sanitizedFundNameList;
    const previousName = this.props.isEdit ? this.props.fund.name.toLowerCase() : "";
    const fundNameCopy = [...this.props.fundNameList];

    if (this.props.isEdit && previousName !== fundName.toLowerCase) {
      sanitizedFundNameList = pull(fundNameCopy, previousName.toLowerCase());
    } else if (this.props.isEdit && previousName === fundName.toLowerCase ) {
      sanitizedFundNameList = pull(fundNameCopy, fundName.toLowerCase());
    } else {
      sanitizedFundNameList = this.props.fundNameList;
    }

    if (sanitizedFundNameList.includes(fundName.toLowerCase())) {
      return false;
    }
    return true;
  }

  render() {
    const {
      isOpen,
      classes,
      fund,
      authentication
    } = this.props;
    const {isSystemAdmin} = authentication;

    const modalTitle = this.props.isEdit ? "Edit Group" : "New Group";
    const onLoadInceptionDate = (this.props.isEdit && fund) ? fund.inceptionDate : moment();

    return (
      <Fragment>
        <Dialog
          open={isOpen}
          onClose={this.closeModal}
          fullWidth
          maxWidth="sm"
          id="fundModel"
          >
        <Grid
            container
            direction="row"
            alignItems="center"
            justify="space-between"
          >
            <DialogTitle classes={{root: classes.dialogTitle}} id = "fundModelHeader">
            {modalTitle}
            </DialogTitle>
          </Grid>
          <PaddedDiv>
            <Formik
              initialValues={
                {...fund,
                  inceptionDate: onLoadInceptionDate,
                  isCollaborationGroup: this.props.fund ? !!this.props.fund.isCollaborationGroup : false,
                }
              }
              validateOnChange={false}
              
              validate={values => {
                const { description, name, inceptionDate } = values;
                let errors = {};
                if (!description) {
                  errors.description = "Required";
                }
                if (!inceptionDate) {
                  errors.inceptionDate = "Required";
                }
                if (!name) {
                  errors.name = "Required";
                } else if (!this.isValidFundName(name)) {
                  errors.name = "Duplicate Group Name Cannot Be Entered";
                  errors.id = "duplicateFundNameError";
                }
                return errors;
              }}

              onSubmit={(values, actions) => {
                this.save(values);
              }}
              render={({values, errors, status, touched, isSubmitting, handleChange, handleBlur, handleSubmit}) => (
                <Fragment>
                  <Grid container direction="row">            
                    <Grid container item={true} xs={8}>
                      <TextField
                        InputProps={{
                          classes: {                  
                            input:classes.inputField,
                            error: classes.error,
                          },
                          disableUnderline:true,
                        }}        
                        InputLabelProps={{
                          FormLabelClasses: {
                            root: classes.labelRoot,
                          }
                        }}
                        fullWidth
                        required
                        id="fundModelNameField"
                        name="name"
                        label="Group Name"
                        value={values.name}
                        error={!!errors.name}
                        onChange={handleChange}                        
                      />
                      {!!errors.name && <FormHelperText id={errors.id}>{errors.name}</FormHelperText>}
                    </Grid>
                  </Grid>
                  <Grid container direction="row" style={{marginTop: 25}}>            
                    <Grid container item={true} xs={8}>
                    <TextField
                        InputProps={{
                          classes: {
                            input:classes.inputField,
                            error: classes.error,
                          },
                          disableUnderline:true,
                        }}
                        InputLabelProps={{
                          FormLabelClasses: {
                            root: classes.labelRoot,
                          }
                        }}
                        fullWidth
                        required
                        id="fundModelDescriptionField"
                        name="description"
                        label="Description"
                        value={values.description}
                        error={!!errors.description}
                        onChange={handleChange}                        
                      />
                      {!!errors.description && <FormHelperText>{errors.description}</FormHelperText>}
                    </Grid>
                  </Grid>
                  <Grid container direction="row" style={{marginTop: 25}}>
                    <Grid item xs={5}>
                      <DateFieldWrapper>
                        <DatePicker
                          id = "fundModelDateField"
                          label="Inception Date"
                          fieldName="inceptionDate"
                          required
                          />
                      </DateFieldWrapper>
                    </Grid>
                  </Grid>
                  {isSystemAdmin && <Grid container direction="row" style={{marginTop: 25}}>
                    <Grid item xs={5}>
                      <FormControlLabel
                        label = {"Collaboration Group"}
                        labelPlacement="end"
                        control = {
                          <CheckboxSelectListInput
                          label={"Collaboration Group"}
                          fieldName={"isCollaborationGroup"}  
                          isDisabled={this.props.isEdit}
                        />}
                        >
                        </FormControlLabel>
                    </Grid>
                  </Grid>}
                  <Grid container direction="row" justify="flex-end">
                    <SecondaryButton id="fundModelCancel" onClick={this.onCancel}>Cancel</SecondaryButton>
                    <PrimaryButton id="fundModelSave" onClick={handleSubmit}>Save</PrimaryButton>
                  </Grid>
                </Fragment>
              )} />
          </PaddedDiv>
        </Dialog>
      </Fragment>
    );
  }
}

export default withStyles(styles)(FundModal);
